export enum RecipeUserEnum {
  BRAND = 'BRAND',
  UGC = 'UGC',
  CHEF = 'CHEF'
}
